"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToggleCardSlots = exports.default = exports.ToggleCard = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _toggleCardClasses = _interopRequireWildcard(require("./toggleCardClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getToggleCardSlots = ownerState => {
  const {
    disabled
  } = ownerState;
  return {
    root: ['root', disabled && 'disabled'],
    icon: ['icon'],
    indicator: ['indicator'],
    input: ['input']
  };
};
exports.getToggleCardSlots = getToggleCardSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getToggleCardSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _toggleCardClasses.getToggleCardUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const ToggleCardRoot = (0, _material.styled)('label', {
  name: 'MuiOriToggleCard',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root]
})(({
  ownerState,
  theme
}) => ({
  position: 'relative',
  display: 'block',
  borderRadius: theme.shape.largeComponentRadius,
  padding: theme.spacing(4, 3),
  cursor: 'pointer',
  userSelect: 'none',
  boxShadow: theme.shadows[0],
  border: `1px solid ${theme.palette.grey[500]}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  transition: theme.transitions.create('box-shadow'),
  [`&.${_toggleCardClasses.default.disabled}`]: {
    borderColor: theme.palette.grey[300],
    color: theme.palette.grey.A700,
    background: theme.palette.grey[100],
    cursor: 'unset'
  },
  ...(ownerState.checked && {
    boxShadow: theme.shadows[3],
    border: `1px solid ${theme.palette.background.paper}`
  })
}));
const Input = (0, _material.styled)('input', {
  name: 'MuiOriToggleCard',
  slot: 'Input',
  overridesResolver: (_, styles) => [styles.input]
})({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1
});
const Indicator = (0, _material.styled)('div', {
  name: 'MuiOriToggleCard',
  slot: 'Indicator',
  overridesResolver: (_, styles) => [styles.indicator]
})(({
  theme,
  ownerState
}) => ({
  position: 'absolute',
  opacity: 0,
  top: -1,
  left: -1,
  width: 50,
  height: 50,
  overflow: 'hidden',
  borderTopLeftRadius: theme.shape.largeComponentRadius,
  transition: theme.transitions.create('opacity'),
  '&:before': {
    position: 'absolute',
    top: 0,
    left: 0,
    content: '""',
    transform: 'translate(-50%, -50%) rotate(45deg)',
    width: 50,
    height: 50,
    zIndex: 0,
    background: theme.palette.primary.main,
    ...(ownerState.disabled && {
      background: theme.palette.grey[400]
    })
  },
  ...(ownerState.checked && {
    opacity: 1
  })
}));
const StyledIcon = (0, _material.styled)(_material.Icon, {
  name: 'MuiOriToggleCard',
  slot: 'Icon',
  overridesResolver: (_, styles) => [styles.icon]
})(({
  theme,
  ownerState
}) => ({
  color: theme.palette.text.primary,
  position: 'relative',
  margin: 1
}));
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
const ToggleCard = exports.ToggleCard = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriToggleCard'
  });
  const {
    checked: checkedProp,
    defaultChecked,
    disabled: disabledProp,
    onBlur,
    onChange: onChangeProp,
    onFocus,
    readOnly: readOnlyProp,
    required,
    inputProps,
    className,
    component: componentProp,
    children,
    Icon = _icons.CheckHeavy,
    IconProps,
    id,
    name: nameProp,
    onFocusVisible,
    value,
    type: typeProp = 'checkbox',
    sx,
    ...otherProps
  } = props;
  const radioGroup = (0, _material.useRadioGroup)();

  // @ts-expect-error -- Incorrect types
  const onChange = (0, _material.createChainedFunction)(onChangeProp, radioGroup?.onChange);
  let type = typeProp;
  let component = componentProp ?? 'label';
  let componentProps = {
    htmlFor: id
  };
  let internalChecked = checkedProp;
  let name = nameProp;
  let inputPropsUpdated = inputProps;
  if (radioGroup) {
    type = 'radio';
    componentProps = {};
    component = componentProp ?? _material.Paper;
    if (typeof internalChecked === 'undefined') {
      internalChecked = areEqualValues(radioGroup.value, value);
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
    inputPropsUpdated = {
      ...inputPropsUpdated,
      role: 'radio'
    };
  }
  const useSwitchProps = {
    checked: internalChecked,
    defaultChecked,
    disabled: disabledProp,
    onBlur,
    onChange,
    onFocus,
    readOnly: readOnlyProp,
    onFocusVisible,
    required
  };
  const {
    getInputProps,
    checked,
    disabled,
    focusVisible,
    readOnly
  } = (0, _base.useSwitch)(useSwitchProps);
  const ownerState = {
    ...props,
    checked,
    disabled,
    focusVisible,
    readOnly
  };
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ToggleCardRoot, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    as: component,
    sx: sx,
    ...componentProps,
    ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Indicator, {
      ownerState: ownerState,
      className: classes.indicator,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
        ownerState: ownerState,
        className: classes.icon,
        as: Icon,
        fontSize: "small",
        ...IconProps
      })
    }), children, /*#__PURE__*/(0, _jsxRuntime.jsx)(Input, {
      id: id,
      ...getInputProps({
        name,
        type,
        value,
        ...inputPropsUpdated
      }),
      ownerState: ownerState,
      className: classes.input,
      "data-checked": internalChecked
    })]
  });
});
var _default = exports.default = ToggleCard;
//# sourceMappingURL=ToggleCard.js.map